import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "red-line--sprite",
  "use": "red-line--sprite-usage",
  "viewBox": "0 0 265 260",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 265 260\" id=\"red-line--sprite\"><defs><style>#red-line--sprite .cls-1{fill:#ee3046;fill-rule:evenodd;}</style></defs><title>red-line</title><g id=\"red-line--sprite_red-line-2\"><path class=\"cls-1\" d=\"M.91,257.57Q8.59,253.33,217,0h48L204.5,72.76,49.93,258.66Q-6.76,261.81.91,257.57Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol